import { isFeaturedOffer } from '@ocx/data-offers';
import { OffersCatalogBody, useOffersCatalog } from '@ocx/feat-offers';
import { ScreenLoaderBackdrop } from '@ocx/ui';

import { useHomeRefreshing, useRegisterRefetch } from '../context/home-refresh.context';
import { HomeFeaturedOffersController } from './home-featured-offers.controller';

/**
 * Home offers when `userExperience.offers.gridLocation === Home`: full carousel and/or local-offers UI on Home.
 */
export const HomeOffersGridOnHomeController = () => {
  const {
    offers,
    offersLoading,
    refetchCatalog,
    categories,
    selectedCategory,
    onCategoryChange,
    isLocalOffersFeatureEnabled,
    hasAltriaOffersNearby,
    isCategoryLoading,
  } = useOffersCatalog({ persistToStorage: true });

  useRegisterRefetch(refetchCatalog);
  const hasSelectedCategoryContent = !!(selectedCategory?.banners.length || selectedCategory?.offers.length);
  useHomeRefreshing(
    (offersLoading && categories.length > 0) || (Boolean(isCategoryLoading) && hasSelectedCategoryContent),
  );
  const featuredOffers = offers.filter(isFeaturedOffer);

  return (
    <>
      <ScreenLoaderBackdrop open={offersLoading && !categories.length} />
      <OffersCatalogBody
        isLocalOffersFeatureEnabled={isLocalOffersFeatureEnabled}
        categories={categories}
        selectedCategory={selectedCategory}
        onCategoryChange={onCategoryChange}
        hasAltriaOffersNearby={hasAltriaOffersNearby}
        isCategoryLoading={isCategoryLoading}
        featuredSlot={<HomeFeaturedOffersController offers={featuredOffers} />}
        // Display "No data view" only when no offers present at all (featured and regular)
        isOffersEmpty={!offersLoading && !featuredOffers.length && !categories.length}
      />
    </>
  );
};
